import Crud from '../views/Cid/Crud'
import Entity from '../views/Cid/Add'

let routes = {
    path: '/cids',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/cids/add',
            name: 'NewCid',
            component: Entity,
            meta: {
                pageTitle: 'Cid',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'Adicionar Cid',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/cids/edit/:id?',
            name: 'EditCid',
            component: Entity,
            meta: {
                pageTitle: 'Cid',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'Editar Cid',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/cids',
            name: 'list-cids',
            component: Crud,
            meta: {
                pageTitle: 'Lista de CIDs',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'CIDs',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
